import { render, staticRenderFns } from "./sectionCard.vue?vue&type=template&id=23c96bbe&"
import script from "./sectionCard.vue?vue&type=script&lang=js&"
export * from "./sectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports